/**
 * Tooltip color definitions
 */
import { palette, createColor } from './palette.colors';

export const tooltipColors = {
  tooltipBackground: createColor(palette.gray.dark, palette.gray.dark),
  tooltipText: createColor(palette.gray.white, palette.dark.textAlt),
  text: createColor(palette.blue.onTint, palette.dark.textAlt),
};